// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ukyg","field":"styles_field__1QCEO","fieldCol":"styles_fieldCol__3Vd0E","diffCol":"styles_diffCol__2hZDK","diff":"styles_diff__31CON"};